// ─────────────────────────────
// Geeft max 2 unieke provincies, met '...' als er meer zijn
function getShortLocationText(advisor) {
  const provinces = advisor?.province
    ? advisor.province.split(",").map(p => p.trim()).filter(Boolean)
    : [];

  const uniqueProvinces = Array.from(new Set(provinces));
  if (!uniqueProvinces.length) return "";

  return uniqueProvinces[0]; // 👈 altijd 1 provincie
}

// HELPERS
// ─────────────────────────────

// Extract surface number
function extractSurfaceNumber(superficie) {
  if (typeof superficie === "number") return superficie;
  if (typeof superficie !== "string") return null;
  const nums = superficie.match(/\d+/g);
  if (!nums) return null;
  if (nums.length >= 2) {
    return Math.round((+nums[0] + +nums[1]) / 2);
  }
  return Number(nums[0]);
}

// Normalize accents + lowercase
function normalizeText(str) {
  return str
    ?.normalize("NFD")
    ?.replace(/[\u0300-\u036f]/g, "")
    ?.toLowerCase();
}

// Surface ranges
const SURFACE_RANGES = {
  Piso: [
    { min: 0, max: 50 },
    { min: 51, max: 80 },
    { min: 81, max: 120 },
    { min: 121, max: 180 },
    { min: 181, max: 350 },
    { min: 351, max: 500 },
    { min: 501, max: 1000 },
  ],
};

function normalizeSurface(surface, propertyType) {
  const s = Number(surface);
  if (!Number.isFinite(s)) return null;
  const ranges = SURFACE_RANGES[propertyType];
  if (!ranges) return s;
  const r = ranges.find(x => s >= x.min && s <= x.max);
  return r ? Math.floor((r.min + r.max) / 2) : s;
}

function renderAdvisors(companies) {
  const resultsContainer = document.getElementById("results");
  if (!resultsContainer) return;

  resultsContainer.innerHTML = companies.map(advisor => {

  const rating = advisor?.rating || 4.7;
  const stars = Math.round(rating);
  const emptyStars = 5 - stars;

  const starSvg =
    '<svg class="w-4 h-4 fill-current text-yellow-400" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
  const emptyStarSvg =
    '<svg class="w-4 h-4 fill-current text-gray-300" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';

  const allStars = Array(stars)
    .fill(starSvg)
    .concat(Array(emptyStars).fill(emptyStarSvg))
    .join("");

  const partnerId = encodeURIComponent(
    advisor?.company?.toLowerCase()?.replace(/\s+/g, "-") || "unknown-advisor"
  );

  const logoUrl =
    advisor?.logo && advisor.logo.trim() !== ""
      ? advisor.logo
      : "https://ceecasasespana.com/logos/LogoES.webp";

  let currentPrice = null;
  let deliveryDays = null;
  if (advisor?.matched_price?.price) {
    currentPrice = Number(advisor.matched_price.price);
    deliveryDays = advisor.matched_price.delivery_days;
  }

  const cardBgClass = advisor?.role === "admin" ? "bg-gray-100" : "bg-white";

  return `
    <div class="partner-card ${cardBgClass} rounded-lg border border-gray-200 p-4 hover:shadow-lg transition-shadow duration-300 mb-4" data-partner-id="${partnerId}">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-4 flex-1">
          <img src="${logoUrl}" alt="${advisor?.company || 'Asesor'} logo" class="w-16 h-16 object-contain" />
          <div class="flex-1">
            <div class="flex items-center gap-6 mb-2">
              <h3 class="text-lg font-bold text-gray-900">Empresa</h3>
              <span class="text-sm text-gray-700">Valoración:</span>
              <span class="flex items-center gap-1">
                ${allStars}
                <span class="text-lg font-semibold text-gray-900">${rating}</span>
              </span>
            </div>

            <h3 class="text-lg font-semibold text-gray-900 mb-2">
              ${advisor?.company || 'Empresa desconocida'}
            </h3>

            <!-- ❌ GEEN PROVINCIES MEER -->

            <div class="flex gap-4 mt-3">
              <button
                class="text-sm px-3 py-1 border border-gray-300 rounded hover:bg-gray-50"
                onclick="toggleAdvisorInfo('${partnerId}', 'about')"
                id="tab-about-${partnerId}">
                Sobre el asesor ↓
              </button>
              <button
                class="text-sm px-3 py-1 border border-gray-300 rounded hover:bg-gray-50"
                onclick="toggleAdvisorInfo('${partnerId}', 'reviews')"
                id="tab-reviews-${partnerId}">
                Opiniones de clientes ↓
              </button>
            </div>
          </div>
        </div>

        <div class="flex flex-col items-end gap-3 ml-4">
          <div class="text-right">
            ${currentPrice !== null ? `
              <span class="text-gray-900 font-semibold">
                ${currentPrice.toFixed(2).replace('.', ',')}€
                <span class="text-sm text-gray-700"> + IVA (21%)</span><br>
                <span class="text-sm text-gray-700">
                  Total: ${(currentPrice * 1.21).toFixed(2).replace('.', ',')}€
                </span>
              </span>
              <div class="text-xs text-gray-500">
                Entrega en ${deliveryDays} día(s) laborables
              </div>
            ` : `
              <span class="text-gray-500 text-sm italic">
                Precio bajo solicitud
              </span>
            `}
          </div>

          <button
            class="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded font-semibold text-sm transition-colors"
            onclick="selectPartner('${partnerId}')">
            Solicitar
          </button>
        </div>
      </div>

      <div id="advisor-content-${partnerId}" class="hidden mt-4 pt-4 border-t border-gray-200">
        <div id="about-content-${partnerId}" class="hidden"></div>
        <div id="reviews-content-${partnerId}" class="hidden"></div>
      </div>
    </div>
  `;
}).join("");

}


export function ComparePagePost() {
  return `

    <div class="hero">
      <div class="hero-content">
        <h1 id="page-title" class="hero-title">Nuestros asesores de certificados energéticos</h1>
        <p class="hero-subtitle">
          Compara nuestros socios certificados en precio y servicio para tomar la mejor decisión para tu certificado energético.
        </p>
      </div>
    </div>
    <section class="section bg-gray-50">
      <div class="container">
        <div class="max-w-6xl mx-auto flex flex-col md:flex-row gap-8">

          <!-- Left Column (1/3 width): Property Results -->
          <div class="w-full md:w-1/3">
            <!-- Property Search Results Container -->
            <div id="property-results-section" class="bg-white rounded-lg shadow-md border border-gray-200 p-6 mb-6">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">Tus <span class="text-lg font-bold text-gray-800 mb-4">datos</span></h3>
              <div id="property-results-content">
                <p class="text-gray-600 text-sm">No hay resultados disponibles. Busca primero una propiedad usando el formulario en la página principal.</p>
              </div>
              <!-- Info box: Que voy a solicitar -->
              <div class="max-w-md rounded-lg border border-gray-200 bg-gray-50 p-6 mt-6">
                <p class="font-semibold text-gray-900 mb-3">
                  Que voy a solicitar:
                </p>
                <p class="text-gray-800 mb-4">
                  Certificación energética
                </p>
                <div class="space-y-3 text-sm text-gray-700 leading-relaxed">
                  <p>
                    <span class="font-semibold">1º- Visita al inmueble</span> para hacer la
                    inspección. Duración 30 minutos aprox.
                  </p>
                  <p>
                    <span class="font-semibold">2º- Elaboración del certificado energético.</span>
                    Plazo 1 o 2 días aprox.
                  </p>
                  <p>
                    <span class="font-semibold">3º- Registro</span> y pago de las tasas si las
                    hubiese en el organismo oficial correspondiente.
                  </p>
                  <p>
                    <span class="font-semibold">4º- Emisión de la etiqueta energética</span> por
                    parte de la administración.
                  </p>
                  <p>
                    <span class="font-semibold">5º- Envío</span> de la documentación vía correo
                    electrónico.
                  </p>
                </div>
              </div>
              <!-- Extra info card: Más información sobre -->
              <div class="max-w-md rounded-xl border border-gray-200 bg-white p-6 mt-4">
                <h2 class="text-base font-semibold text-gray-900 mb-2">
                  Más información sobre:
                </h2>
                <p class="text-gray-800 mb-3">
                  Certificación energética
                </p>
                <p class="text-sm text-gray-700 leading-relaxed mb-4">
                  El certificado energético
                  <span class="font-semibold">
                    imprescindible para vender o alquilar un inmueble
                  </span>
                  informa sobre el consumo energético y sobre las emisiones de CO2 de un inmueble.
                  <span class="font-semibold">
                    Tienen una validez de 10 años.
                  </span>
                </p>
                <a
                  href="/faq-customer/"
                  class="text-sm font-semibold text-green-600 hover:text-green-700 transition"
                >
                  Leer más
                </a>
              </div>
              <!-- Málaga municipios dropdown -->
              <div id="malaga-municipios-dropdown-container" class="mb-6 w-full">
                <!-- Dropdown will be rendered here if Málaga is selected -->
              </div>
            </div>
            <div class="bg-transparent border-transparent shadow-none rounded-lg mb-6" style="min-height:120px; padding:0;"></div>
          </div>

          <!-- Right Column (2/3 width): Advisors section -->
          <div class="w-full md:w-2/3 mt-8 md:mt-0">
            <!-- Advisors heading & filters -->
            <div class="mb-6 flex items-center justify-between">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">Asesores disponibles</h3>
              <!-- Sorting/filter UI verwijderd, filtering gebeurt alleen backend -->
            </div>

          
<!-- Filters -->
<div class="bg-white border border-gray-200 rounded-lg p-4 mb-6">
  <div class="flex flex-wrap gap-3 items-center">
    <span class="text-sm font-semibold text-gray-700">Ordenar por:</span>

    <button
      onclick="sortAdvisors('price')"
      class="px-3 py-1 text-sm border rounded hover:bg-gray-100">
      💶 Precio más bajo
    </button>

    <button
      onclick="sortAdvisors('delivery')"
      class="px-3 py-1 text-sm border rounded hover:bg-gray-100">
      ⚡ Entrega más rápida
    </button>
  </div>
</div>


            <!-- Advisor results list -->
            <div id="results" class="space-y-4 mt-4"></div>
          </div>
        </div>
    </section>
    
  `;
}

export async function initializeComparePagePost() {
  const content = document.getElementById("property-results-content");
  if (!content) return;

  const raw = sessionStorage.getItem("propertySearchDataPost");
  if (!raw) {
    content.innerHTML = `<p>No hay datos disponibles.</p>`;
    return;
  }

   

  const data = JSON.parse(raw);


    // Render advisor cards
// Render advisor cards — 



   
  // ✅ Zorg dat BookEPC altijd dezelfde data krijgt
try {
  const completePropertyData = {
    ...data,
    timestamp: Date.now(),
    source: 'compare-page-post'
  };

  // 🔑 ENIGE waarheid voor vervolgpagina’s
  //localStorage.setItem(
   // 'bookingPropertyData',
   // JSON.stringify(completePropertyData)
  //);

  // Optional: sessionStorage synchroon houden
  sessionStorage.setItem(
    'bookingPropertyData',
    JSON.stringify(completePropertyData)
  );

  console.log('[ComparePagePost] bookingPropertyData opgeslagen');
} catch (e) {
  console.warn('[ComparePagePost] Opslaan property data mislukt', e);
}


  // Try multiple keys for compatibility
  let buildingType = data.buildingType || data.tipo || data.type || '';
  let serviceType = data.serviceType || data.servicio || data.service || '';
  // Fallbacks for empty/undefined values
  if (!buildingType || buildingType === '' || buildingType === 'undefined' || buildingType === 'null') {
    buildingType = 'No especificado';
  }
  if (!serviceType || serviceType === '' || serviceType === 'undefined' || serviceType === 'null') {
    serviceType = 'No especificado';
  }
// Zonas de trabajo netjes tonen

let zonasValue = data.municipios;
if (Array.isArray(zonasValue)) {
  // Limit to 4 words, then add '+' if more
  if (zonasValue.length > 4) {
    zonasValue = zonasValue.slice(0, 4).join(", ") + ' +';
  } else {
    zonasValue = zonasValue.join(", ");
  }
}

content.innerHTML = `
  <div class="border-b pb-4 mb-4">
    <div class="mb-3">
      <div class="text-sm"><strong>Tipo de edificio:</strong> <span class="text-gray-600">${buildingType}</span></div>
      <div class="text-sm"><strong>Tipo de servicio:</strong> <span class="text-gray-600">${serviceType}</span></div>
    </div>
  </div>
  <table class="text-sm">
    <tr><td>Tipo</td><td>${data.tipo || "-"}</td></tr>
    <tr><td>Superficie</td><td>${data.superficie || "-"}</td></tr>
    <tr><td>CP</td><td>${data.codigo_postal || "-"}</td></tr>
    <tr><td>Provincia</td><td>${data.provincia || data.province || "-"}</td></tr>
    <tr><td>Zona de trabajo</td><td>${zonasValue || "-"}</td></tr>
  </table>
`;



  // 🔥 HIER GEBEURT HET
  await filterAdvisorsByPropertyLocation(data);
}
window.sortAdvisors = function (type) {
  if (!Array.isArray(window.companies)) return;

  const sorted = [...window.companies].sort((a, b) => {
    const priceA = a?.matched_price?.price ?? Infinity;
    const priceB = b?.matched_price?.price ?? Infinity;

    const deliveryA = a?.matched_price?.delivery_days ?? Infinity;
    const deliveryB = b?.matched_price?.delivery_days ?? Infinity;

    if (type === 'price') {
      return priceA - priceB;
    }

    if (type === 'delivery') {
      return deliveryA - deliveryB;
    }

    return 0;
  });

  renderAdvisors(sorted);
};

// ─────────────────────────────
// API CALL (1×)
// ─────────────────────────────

export async function filterAdvisorsByPropertyLocation(propertyData) {
  const resultsContainer = document.getElementById("results");
  if (!resultsContainer) return;

  // ── PAYLOAD
  const payload = {};

if (propertyData.provincia || propertyData.province) {
  payload.province = normalizeText(
    propertyData.provincia || propertyData.province
  );
}

// 👇 HIER TOEVOEGEN
if (Array.isArray(propertyData.municipios) && propertyData.municipios.length) {
  payload.city = propertyData.municipios
    .map(c => normalizeText(c))
    .join(",");
}

  if (propertyData.tipo) {
    payload.property_type = propertyData.tipo;
  }

  if (propertyData.superficie && payload.property_type) {
    const s = extractSurfaceNumber(propertyData.superficie);
    if (Number.isFinite(s)) {
      payload.surface = normalizeSurface(s, payload.property_type);
    }
  }

  

  // UI loading
  resultsContainer.innerHTML = `
    <p class="text-gray-500">Buscando asesores en ${payload.province}…</p>
  `;

  try {
    const baseUrl =
      window.location.port === "4174" ? "http://localhost:4000" : "";

    const params = new URLSearchParams(payload).toString();
    const res = await fetch(`${baseUrl}/api/companies?${params}`);

    if (!res.ok) throw new Error("Fetch failed");

const companies = await res.json();
window.companies = companies;

if (!companies.length) {
  resultsContainer.innerHTML =
    `<p class="text-gray-500">No se encontraron asesores.</p>`;
  return;
}

renderAdvisors(companies); // 👈 VERPLICHT




// Toggle voor "Over adviseur" / "Klantervaringen" identiek aan ComparePage.js
window.toggleAdvisorInfo = function (partnerId, tabType) {
  const contentDiv = document.getElementById(`advisor-content-${partnerId}`);
  const aboutContent = document.getElementById(`about-content-${partnerId}`);
  const reviewsContent = document.getElementById(`reviews-content-${partnerId}`);
  const aboutTab = document.getElementById(`tab-about-${partnerId}`);
  const reviewsTab = document.getElementById(`tab-reviews-${partnerId}`);

  const wasAboutVisible = !aboutContent.classList.contains("hidden");
  const wasReviewsVisible = !reviewsContent.classList.contains("hidden");

  // Reset alles
  aboutContent.classList.add("hidden");
  reviewsContent.classList.add("hidden");
  aboutTab.classList.remove("bg-gray-100", "font-medium");
  reviewsTab.classList.remove("bg-gray-100", "font-medium");

  if (
    (tabType === "about" && wasAboutVisible) ||
    (tabType === "reviews" && wasReviewsVisible)
  ) {
    contentDiv.classList.add("hidden");
    return;
  }

  contentDiv.classList.remove("hidden");

  if (tabType === "about") {
    // Buscar los datos del asesor
    const advisor = window.companies.find(
      (a) =>
        encodeURIComponent(
          a.company?.toLowerCase().replace(/\s+/g, "-") || "",
        ) === partnerId,
    );
    aboutContent.innerHTML = `
      <h4 class="font-semibold text-gray-900 mb-2">Sobre ${advisor?.company || partnerId}</h4>
      <p class="text-sm text-gray-600">${advisor?.description ? advisor.description : "No hay descripción disponible."}</p>
    `;
    aboutContent.classList.remove("hidden");
    aboutTab.classList.add("bg-gray-100", "font-medium");
  } else {
    // Buscar el índice del asesor para la valoración
    const index = window.companies.findIndex(
      (a) =>
        encodeURIComponent(
          a.company?.toLowerCase().replace(/\s+/g, "-") || "",
        ) === partnerId,
    );
    const rating = window.companies[index]?.rating || 3.6;
    const reviews = window.companies[index]?.reviews || 29;
    const stars = Math.round(rating);

    const starSvg =
      '<svg class="w-4 h-4 fill-current text-yellow-400" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const emptyStarSvg =
      '<svg class="w-4 h-4 fill-current text-gray-300" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
    const allStars = Array(stars)
      .fill(starSvg)
      .concat(Array(5 - stars).fill(emptyStarSvg))
      .join("");

    reviewsContent.innerHTML = `
      <h4 class="font-semibold text-gray-900 mb-4">Opiniones de clientes</h4>
      <div class="bg-gray-50 p-4 rounded-lg">
        <div class="flex items-center mb-3">
          <div class="flex">${allStars}</div>
          <span class="ml-3 text-lg font-semibold">${rating}</span>
          <span class="ml-2 text-sm text-gray-600">(${reviews})</span>
        </div>
        <p class="text-sm text-gray-600 italic mb-2">
          "Servicio rápido y evaluación profesional. El certificado energético fue entregado exactamente en el plazo prometido."
        </p>
        <p class="text-xs text-gray-500">- Cliente verificado</p>
      </div>
    `;
    reviewsContent.classList.remove("hidden");
    reviewsTab.classList.add("bg-gray-100", "font-medium");
  }
};


window.resetAdvisorAndGo = function () {
  console.log('[ComparePagePost] Team geselecteerd');

  sessionStorage.setItem(
    'selectedAdvisorData',
    JSON.stringify({
      company: 'Team CEE Casas España'
    })
  );

  window.location.href = '/book-epc/';
};


  } catch (err) {
    console.error(err);
    resultsContainer.innerHTML =
      `<p class="text-gray-500">No se encontraron asesores.</p>`;
  }
}